module.exports = __webpack_public_path__ + "static/img/anos_50.d4bb16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_50.png
// module id = MNX6
// module chunks = 0